import React from 'react'
import './styles.scss'
import classNames from 'classnames'

function Button({ className, children, primary, secondary, label, onClick }) {
  return (
    <button
      className={classNames({
        [className]: true,
        'mai-btn': true,
        'mai-btn--primary': primary,
        'mai-btn--secondary': secondary,
      })}
      aria-label={label}
      onClick={onClick}
    >
      {children}
    </button>
  )
}

export default Button
